import ProductSearchItem from "./productSearchItem.comp";

export default function ProductSearchList({
  selectedProductIds,
  removeProduct,
}: {
  removeProduct: (productId: string) => void;
  selectedProductIds: string[];
}) {
  if (!selectedProductIds) return null;

  return (
    <div id="related-product-list" className="flex gap-4 flex-wrap mt-4">
      {selectedProductIds.map((id) => (
        <ProductSearchItem key={id} productId={id} removeProduct={removeProduct} />
      ))}
    </div>
  );
}
